import { Popover } from '@mui/material';
import React, { useState, useImperativeHandle, forwardRef } from 'react';

const defaultPosition = {
  top: 0,
  left: 0,
};

const MenuCardMemo = ({ children, ...props }, ref) => {
  const [position, setPosition] = useState(defaultPosition);
  const [open, setOpen] = useState(false);

  const show = (left, top) => {
    setPosition({ top, left });
    setOpen(true);
  };

  const hide = () => {
    setOpen(false);
    setPosition(defaultPosition);
  };

  useImperativeHandle(ref, () => ({
    show,
    hide,
  }));

  return (
    <Popover
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={{ top: position.top, left: position.left }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={hide}
      {...props}>
      {children}
    </Popover>
  );
};

export const MenuCard = React.memo(forwardRef(MenuCardMemo));
